// 工作流系统的默认模板

export interface TemplateContext {
  projectName: string;
  projectRoot: string;
}

export class WorkflowTemplates {
  static getInitCommand(context?: Partial<TemplateContext>): string {
    return `# 🚀 Project Initialization

## Status Check
\`\`\`bash
git status
pwd
ls -la
\`\`\`

## Environment
\`\`\`bash
node --version
npm --version
\`\`\`

## Dependencies
\`\`\`bash
npm install
\`\`\`

## Quick Start
- Development: \`npm run dev\`
- Build: \`npm run build\`
- Test: \`npm test\`
`;
  }

  static getTodoCommand(): string {
    return `# 📋 Task Management

> Auto-synced from project TODO files

## High Priority
_Tasks will be synced here_

## In Progress
_Tasks will be synced here_

## Completed
_Tasks will be synced here_

---

Run \`workflow sync\` to update tasks.
`;
  }

  static getContextCommand(projectName: string): string {
    return `# 🏗️ Project Context

## Overview
Project: ${projectName}

## Structure
\`\`\`
src/
├── components/
├── utils/
└── index.ts
\`\`\`

## Commands
\`\`\`bash
npm run dev
npm test
npm run build
\`\`\`
`;
  }

  static getReviewCommand(): string {
    return `# 🔍 Code Review Checklist

## Before Commit
- [ ] Code follows style guide
- [ ] Tests pass
- [ ] No debug code
- [ ] Documentation updated

## Security
- [ ] No hardcoded secrets
- [ ] Input validation
- [ ] Dependencies updated

## Performance
- [ ] No unnecessary renders
- [ ] Optimized queries
- [ ] Bundle size checked
`;
  }

  static getFeatureWorkflow(): string {
    return `name: Feature Development
description: Workflow for developing new features
phases:
  - name: Planning
    tasks:
      - Define requirements
      - Create design
      - Break down tasks
  - name: Implementation
    tasks:
      - Create branch
      - Implement feature
      - Write tests
  - name: Review
    tasks:
      - Self review
      - Create PR
      - Address feedback
`;
  }

  static getBugfixWorkflow(): string {
    return `name: Bug Fix
description: Workflow for fixing bugs
phases:
  - name: Investigation
    tasks:
      - Reproduce issue
      - Find root cause
  - name: Fix
    tasks:
      - Implement fix
      - Add tests
  - name: Verify
    tasks:
      - Test fix
      - Check regressions
`;
  }

  static getRefactorWorkflow(): string {
    return `name: Refactoring
description: Workflow for code refactoring
phases:
  - name: Analysis
    tasks:
      - Identify targets
      - Plan approach
  - name: Refactor
    tasks:
      - Refactor code
      - Update tests
  - name: Validate
    tasks:
      - Run tests
      - Check behavior
`;
  }
}